import React, { useMemo } from 'react'
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom'

interface LinkProps extends RouterLinkProps {
  variant?: 'contained' | 'outlined' | 'text'
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
}

function Link({
  variant = 'contained',
  startIcon = undefined,
  endIcon = undefined,
  children,
  className,
  ...props
}: LinkProps) {
  const classNames = useMemo(() => {
    let result = 'button'
    if (variant === 'outlined') result += ' buttonOutlined'
    if (variant === 'text') result += ' buttonText'
    if (className) result += ` ${className}`
    return result
  }, [className, variant])

  return (
    <RouterLink className={classNames} {...props}>
      {startIcon}
      <span className="buttonLabel">{children}</span>
      {endIcon}
    </RouterLink>
  )
}

export default Link
